import { render, staticRenderFns } from "./RecordPage.vue?vue&type=template&id=44fa5ed3&scoped=true&"
import script from "./RecordPage.vue?vue&type=script&lang=js&"
export * from "./RecordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa5ed3",
  null
  
)

export default component.exports